// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* assets/quiz-style.css */

/* Reset für Quiz-Container */
body #camera-quiz-root * {
    box-sizing: border-box !important;
    margin: 0 !important;
    padding: 0 !important;
}

/* Base Container */
body #camera-quiz-root .camera-quiz-container {
    width: 100% !important;
    max-width: 800px !important;
    margin: 2rem auto !important;
    padding: 0 1rem !important;
    font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
}

/* Quiz Card */
body #camera-quiz-root .quiz-card {
    background: #ffffff !important;
    border-radius: 20px !important;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
    overflow: hidden !important;
}

/* Content Padding */
body #camera-quiz-root .quiz-content {
    padding: 2.5rem 2rem !important;
}

/* Progress Bar */
body #camera-quiz-root .quiz-progress {
    margin: 0 15px 25px 15px !important;
    padding: 0 !important;
    display: flex !important;
    gap: 6px !important;
}

body #camera-quiz-root .quiz-progress-step {
    height: 4px !important;
    flex: 1 !important;
    border-radius: 2px !important;
    background: #e5e7eb !important;
    transition: background-color 0.3s ease !important;
}

body #camera-quiz-root .quiz-progress-step.active {
    background: #3b82f6 !important;
}

/* Question */
body #camera-quiz-root .quiz-question {
    font-size: 1.5rem !important;
    font-weight: 700 !important;
    color: #1f2937 !important;
    margin: 15px 15px 25px 15px !important;
    line-height: 1.3 !important;
    padding: 0 !important;
}

/* Selection Counter */
body #camera-quiz-root .quiz-selection-counter {
    color: #6b7280 !important;
    font-size: 0.875rem !important;
    margin: -15px 15px 15px 15px !important;
    text-align: center !important;
}

/* Options */
body #camera-quiz-root .quiz-options {
    display: flex !important;
    flex-direction: column !important;
    gap: 0.75rem !important;
    margin: 0 15px !important;
    padding: 0 !important;
}

/* Buttons */
body #camera-quiz-root .quiz-button {
    width: 100% !important;
    background: #ffffff !important;
    border: 2px solid #e5e7eb !important;
    border-radius: 12px !important;
    padding: 1rem 1.5rem !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    transition: all 0.2s ease !important;
    text-align: left !important;
    position: relative !important;
}

body #camera-quiz-root .quiz-button.selected {
    border-color: #3b82f6 !important;
    background: #eff6ff !important;
}

body #camera-quiz-root .quiz-button:hover:not(:disabled) {
    border-color: #3b82f6 !important;
    background: #f8fafc !important;
    transform: translateY(-1px) !important;
}

body #camera-quiz-root .quiz-button:disabled {
    opacity: 0.5 !important;
    cursor: not-allowed !important;
    background: #f9fafb !important;
}

body #camera-quiz-root .quiz-button svg {
    width: 24px !important;
    height: 24px !important;
    margin-right: 1rem !important;
    color: #3b82f6 !important;
    flex-shrink: 0 !important;
}

body #camera-quiz-root .quiz-button span {
    color: #374151 !important;
    font-size: 1rem !important;
    font-weight: normal !important;
}

/* Continue Button */
body #camera-quiz-root .quiz-continue-button {
    width: 100% !important;
    padding: 1rem !important;
    background: #3b82f6 !important;
    color: white !important;
    border: none !important;
    border-radius: 12px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease !important;
    text-align: center !important;
    margin-top: 1rem !important;
}

body #camera-quiz-root .quiz-continue-button:hover {
    background: #2563eb !important;
}

/* Navigation */
body #camera-quiz-root .quiz-navigation {
    margin: 20px 15px 0 15px !important;
    padding: 0 !important;
}

body #camera-quiz-root .quiz-back-button {
    width: 100% !important;
    background: #ffffff !important;
    border: 2px solid #e5e7eb !important;
    border-radius: 12px !important;
    padding: 1rem 1.5rem !important;
    cursor: pointer !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    text-align: center !important;
}

body #camera-quiz-root .quiz-back-button:hover {
    border-color: #3b82f6 !important;
    background: #f8fafc !important;
    transform: translateY(-1px) !important;
}

/* Results Section */
body #camera-quiz-root .quiz-results-container {
    margin: 0 15px !important;
    padding: 0 !important;
}

body #camera-quiz-root .quiz-title {
    font-size: 1.875rem !important;
    font-weight: 700 !important;
    color: #1f2937 !important;
    margin-bottom: 1.5rem !important;
}

/* Main Result */
body #camera-quiz-root .quiz-result {
    background: #eff6ff !important;
    padding: 1.5rem !important;
    border-radius: 12px !important;
    margin-bottom: 1.5rem !important;
}

body #camera-quiz-root .quiz-result-title {
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    color: #1f2937 !important;
    margin-bottom: 1rem !important;
}

body #camera-quiz-root .quiz-result-description {
    color: #4b5563 !important;
    margin-bottom: 1rem !important;
    line-height: 1.5 !important;
}

body #camera-quiz-root .quiz-result-price {
    font-size: 1.25rem !important;
    font-weight: 600 !important;
    color: #3b82f6 !important;
    margin-bottom: 1rem !important;
}

/* Score Anzeige */
body #camera-quiz-root .quiz-score {
    color: #3b82f6 !important;
    font-size: 1.1rem !important;
    font-weight: 600 !important;
    margin-bottom: 1rem !important;
}

/* Alternative Recommendations */
body #camera-quiz-root .quiz-alternatives {
    margin-top: 1.5rem !important;
}

body #camera-quiz-root .quiz-alternatives-title {
    font-size: 1.5rem !important;
    font-weight: 600 !important;
    color: #1f2937 !important;
    margin-bottom: 1rem !important;
}

body #camera-quiz-root .quiz-alternative {
    background: #f8fafc !important;
    padding: 1.5rem !important;
    border-radius: 12px !important;
    margin-bottom: 1rem !important;
    border: 1px solid #e5e7eb !important;
}

body #camera-quiz-root .quiz-alternative-title {
    font-size: 1.25rem !important;
    font-weight: 600 !important;
    color: #1f2937 !important;
    margin-bottom: 0.75rem !important;
}

body #camera-quiz-root .quiz-alternative-description {
    color: #4b5563 !important;
    margin-bottom: 0.75rem !important;
}

body #camera-quiz-root .quiz-alternative-price {
    font-size: 1.125rem !important;
    font-weight: 600 !important;
    color: #3b82f6 !important;
    margin-bottom: 0.75rem !important;
}

/* List Styles */
body #camera-quiz-root .quiz-highlights-list {
    list-style: none !important;
    margin: 0 !important;
    padding: 0 !important;
}

body #camera-quiz-root .quiz-highlight-item {
    display: flex !important;
    align-items: start !important;
    margin-bottom: 0.5rem !important;
    color: #4b5563 !important;
}

body #camera-quiz-root .quiz-bullet {
    margin-right: 0.5rem !important;
}

/* Restart Button */
body #camera-quiz-root .quiz-restart-button {
    width: 100% !important;
    padding: 1rem !important;
    background: #3b82f6 !important;
    color: white !important;
    border: none !important;
    border-radius: 12px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    transition: background-color 0.2s ease !important;
    text-align: center !important;
}

body #camera-quiz-root .quiz-restart-button:hover {
    background: #2563eb !important;
}

/* Loading State */
body #camera-quiz-root .quiz-loading {
    text-align: center !important;
    padding: 2rem !important;
    color: #6b7280 !important;
}

/* Mobile Styles */
@media (max-width: 640px) {
    /* Container Anpassungen */
    body #camera-quiz-root .camera-quiz-container {
        margin: 1rem auto !important;
        padding: 0 0.5rem !important;
    }

    /* Content Padding verringern */
    body #camera-quiz-root .quiz-content {
        padding: 1.5rem 1rem !important;
    }
    
    /* Kleinere Überschrift */
    body #camera-quiz-root .quiz-question {
        font-size: 1.25rem !important;
        margin: 10px 10px 20px 10px !important;
    }

    /* Button Anpassungen */
    body #camera-quiz-root .quiz-button {
        padding: 0.875rem 1rem !important;
        min-height: 60px !important;
    }

    body #camera-quiz-root .quiz-button span {
        font-size: 0.9rem !important;
        line-height: 1.3 !important;
    }

    body #camera-quiz-root .quiz-button svg {
        width: 20px !important;
        height: 20px !important;
        margin-right: 0.75rem !important;
    }

    /* Selection Counter */
    body #camera-quiz-root .quiz-selection-counter {
        font-size: 0.8rem !important;
        margin: -10px 10px 10px 10px !important;
    }

    /* Back Button */
    body #camera-quiz-root .quiz-back-button {
        padding: 0.875rem 1rem !important;
    }
}

/* Noch kleinere Bildschirme */
@media (max-width: 380px) {
    body #camera-quiz-root .quiz-content {
        padding: 1rem 0.5rem !important;
    }

    body #camera-quiz-root .quiz-button {
        padding: 0.75rem 0.875rem !important;
    }

    body #camera-quiz-root .quiz-button span {
        font-size: 0.85rem !important;
    }
}`, "",{"version":3,"sources":["webpack://./assets/quiz-style.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B,6BAA6B;AAC7B;IACI,iCAAiC;IACjC,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;IACtB,2BAA2B;IAC3B,4BAA4B;IAC5B,0BAA0B;IAC1B,oGAAoG;AACxG;;AAEA,cAAc;AACd;IACI,8BAA8B;IAC9B,8BAA8B;IAC9B,4FAA4F;IAC5F,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,+BAA+B;AACnC;;AAEA,iBAAiB;AACjB;IACI,mCAAmC;IACnC,qBAAqB;IACrB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,6BAA6B;IAC7B,8BAA8B;IAC9B,iDAAiD;AACrD;;AAEA;IACI,8BAA8B;AAClC;;AAEA,aAAa;AACb;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,sCAAsC;IACtC,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA,sBAAsB;AACtB;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,uCAAuC;IACvC,6BAA6B;AACjC;;AAEA,YAAY;AACZ;IACI,wBAAwB;IACxB,iCAAiC;IACjC,uBAAuB;IACvB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,YAAY;AACZ;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,oCAAoC;IACpC,8BAA8B;IAC9B,+BAA+B;IAC/B,0BAA0B;IAC1B,wBAAwB;IACxB,8BAA8B;IAC9B,oCAAoC;IACpC,2BAA2B;IAC3B,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;AAClC;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;IAC7B,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA,oBAAoB;AACpB;IACI,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;IACvB,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,iDAAiD;IACjD,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,eAAe;AACf;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,oCAAoC;IACpC,8BAA8B;IAC9B,+BAA+B;IAC/B,0BAA0B;IAC1B,wBAAwB;IACxB,8BAA8B;IAC9B,kCAAkC;IAClC,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,8BAA8B;IAC9B,sCAAsC;AAC1C;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA,gBAAgB;AAChB;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA,kBAAkB;AAClB;IACI,yBAAyB;IACzB,4BAA4B;IAC5B,2BAA2B;IAC3B,8BAA8B;AAClC;;AAEA,gCAAgC;AAChC;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;IAC3B,yBAAyB;IACzB,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;IAC1B,8BAA8B;IAC9B,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA;IACI,8BAA8B;IAC9B,2BAA2B;IAC3B,yBAAyB;IACzB,iCAAiC;AACrC;;AAEA,gBAAgB;AAChB;IACI,2BAA2B;IAC3B,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;AACnC;;AAEA,mBAAmB;AACnB;IACI,sBAAsB;IACtB,wBAAwB;IACxB,8BAA8B;IAC9B,uBAAuB;IACvB,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;IAC3B,0BAA0B;IAC1B,iDAAiD;IACjD,6BAA6B;AACjC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,kBAAkB;AAClB;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA,kBAAkB;AAClB;IACI,0BAA0B;IAC1B;QACI,4BAA4B;QAC5B,4BAA4B;IAChC;;IAEA,+BAA+B;IAC/B;QACI,+BAA+B;IACnC;;IAEA,yBAAyB;IACzB;QACI,6BAA6B;QAC7B,sCAAsC;IAC1C;;IAEA,uBAAuB;IACvB;QACI,iCAAiC;QACjC,2BAA2B;IAC/B;;IAEA;QACI,4BAA4B;QAC5B,2BAA2B;IAC/B;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,gCAAgC;IACpC;;IAEA,sBAAsB;IACtB;QACI,4BAA4B;QAC5B,uCAAuC;IAC3C;;IAEA,gBAAgB;IAChB;QACI,iCAAiC;IACrC;AACJ;;AAEA,8BAA8B;AAC9B;IACI;QACI,+BAA+B;IACnC;;IAEA;QACI,oCAAoC;IACxC;;IAEA;QACI,6BAA6B;IACjC;AACJ","sourcesContent":["/* assets/quiz-style.css */\n\n/* Reset für Quiz-Container */\nbody #camera-quiz-root * {\n    box-sizing: border-box !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\n/* Base Container */\nbody #camera-quiz-root .camera-quiz-container {\n    width: 100% !important;\n    max-width: 800px !important;\n    margin: 2rem auto !important;\n    padding: 0 1rem !important;\n    font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif !important;\n}\n\n/* Quiz Card */\nbody #camera-quiz-root .quiz-card {\n    background: #ffffff !important;\n    border-radius: 20px !important;\n    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;\n    overflow: hidden !important;\n}\n\n/* Content Padding */\nbody #camera-quiz-root .quiz-content {\n    padding: 2.5rem 2rem !important;\n}\n\n/* Progress Bar */\nbody #camera-quiz-root .quiz-progress {\n    margin: 0 15px 25px 15px !important;\n    padding: 0 !important;\n    display: flex !important;\n    gap: 6px !important;\n}\n\nbody #camera-quiz-root .quiz-progress-step {\n    height: 4px !important;\n    flex: 1 !important;\n    border-radius: 2px !important;\n    background: #e5e7eb !important;\n    transition: background-color 0.3s ease !important;\n}\n\nbody #camera-quiz-root .quiz-progress-step.active {\n    background: #3b82f6 !important;\n}\n\n/* Question */\nbody #camera-quiz-root .quiz-question {\n    font-size: 1.5rem !important;\n    font-weight: 700 !important;\n    color: #1f2937 !important;\n    margin: 15px 15px 25px 15px !important;\n    line-height: 1.3 !important;\n    padding: 0 !important;\n}\n\n/* Selection Counter */\nbody #camera-quiz-root .quiz-selection-counter {\n    color: #6b7280 !important;\n    font-size: 0.875rem !important;\n    margin: -15px 15px 15px 15px !important;\n    text-align: center !important;\n}\n\n/* Options */\nbody #camera-quiz-root .quiz-options {\n    display: flex !important;\n    flex-direction: column !important;\n    gap: 0.75rem !important;\n    margin: 0 15px !important;\n    padding: 0 !important;\n}\n\n/* Buttons */\nbody #camera-quiz-root .quiz-button {\n    width: 100% !important;\n    background: #ffffff !important;\n    border: 2px solid #e5e7eb !important;\n    border-radius: 12px !important;\n    padding: 1rem 1.5rem !important;\n    cursor: pointer !important;\n    display: flex !important;\n    align-items: center !important;\n    transition: all 0.2s ease !important;\n    text-align: left !important;\n    position: relative !important;\n}\n\nbody #camera-quiz-root .quiz-button.selected {\n    border-color: #3b82f6 !important;\n    background: #eff6ff !important;\n}\n\nbody #camera-quiz-root .quiz-button:hover:not(:disabled) {\n    border-color: #3b82f6 !important;\n    background: #f8fafc !important;\n    transform: translateY(-1px) !important;\n}\n\nbody #camera-quiz-root .quiz-button:disabled {\n    opacity: 0.5 !important;\n    cursor: not-allowed !important;\n    background: #f9fafb !important;\n}\n\nbody #camera-quiz-root .quiz-button svg {\n    width: 24px !important;\n    height: 24px !important;\n    margin-right: 1rem !important;\n    color: #3b82f6 !important;\n    flex-shrink: 0 !important;\n}\n\nbody #camera-quiz-root .quiz-button span {\n    color: #374151 !important;\n    font-size: 1rem !important;\n    font-weight: normal !important;\n}\n\n/* Continue Button */\nbody #camera-quiz-root .quiz-continue-button {\n    width: 100% !important;\n    padding: 1rem !important;\n    background: #3b82f6 !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 12px !important;\n    font-weight: 600 !important;\n    cursor: pointer !important;\n    transition: background-color 0.2s ease !important;\n    text-align: center !important;\n    margin-top: 1rem !important;\n}\n\nbody #camera-quiz-root .quiz-continue-button:hover {\n    background: #2563eb !important;\n}\n\n/* Navigation */\nbody #camera-quiz-root .quiz-navigation {\n    margin: 20px 15px 0 15px !important;\n    padding: 0 !important;\n}\n\nbody #camera-quiz-root .quiz-back-button {\n    width: 100% !important;\n    background: #ffffff !important;\n    border: 2px solid #e5e7eb !important;\n    border-radius: 12px !important;\n    padding: 1rem 1.5rem !important;\n    cursor: pointer !important;\n    display: flex !important;\n    align-items: center !important;\n    justify-content: center !important;\n    text-align: center !important;\n}\n\nbody #camera-quiz-root .quiz-back-button:hover {\n    border-color: #3b82f6 !important;\n    background: #f8fafc !important;\n    transform: translateY(-1px) !important;\n}\n\n/* Results Section */\nbody #camera-quiz-root .quiz-results-container {\n    margin: 0 15px !important;\n    padding: 0 !important;\n}\n\nbody #camera-quiz-root .quiz-title {\n    font-size: 1.875rem !important;\n    font-weight: 700 !important;\n    color: #1f2937 !important;\n    margin-bottom: 1.5rem !important;\n}\n\n/* Main Result */\nbody #camera-quiz-root .quiz-result {\n    background: #eff6ff !important;\n    padding: 1.5rem !important;\n    border-radius: 12px !important;\n    margin-bottom: 1.5rem !important;\n}\n\nbody #camera-quiz-root .quiz-result-title {\n    font-size: 1.5rem !important;\n    font-weight: 600 !important;\n    color: #1f2937 !important;\n    margin-bottom: 1rem !important;\n}\n\nbody #camera-quiz-root .quiz-result-description {\n    color: #4b5563 !important;\n    margin-bottom: 1rem !important;\n    line-height: 1.5 !important;\n}\n\nbody #camera-quiz-root .quiz-result-price {\n    font-size: 1.25rem !important;\n    font-weight: 600 !important;\n    color: #3b82f6 !important;\n    margin-bottom: 1rem !important;\n}\n\n/* Score Anzeige */\nbody #camera-quiz-root .quiz-score {\n    color: #3b82f6 !important;\n    font-size: 1.1rem !important;\n    font-weight: 600 !important;\n    margin-bottom: 1rem !important;\n}\n\n/* Alternative Recommendations */\nbody #camera-quiz-root .quiz-alternatives {\n    margin-top: 1.5rem !important;\n}\n\nbody #camera-quiz-root .quiz-alternatives-title {\n    font-size: 1.5rem !important;\n    font-weight: 600 !important;\n    color: #1f2937 !important;\n    margin-bottom: 1rem !important;\n}\n\nbody #camera-quiz-root .quiz-alternative {\n    background: #f8fafc !important;\n    padding: 1.5rem !important;\n    border-radius: 12px !important;\n    margin-bottom: 1rem !important;\n    border: 1px solid #e5e7eb !important;\n}\n\nbody #camera-quiz-root .quiz-alternative-title {\n    font-size: 1.25rem !important;\n    font-weight: 600 !important;\n    color: #1f2937 !important;\n    margin-bottom: 0.75rem !important;\n}\n\nbody #camera-quiz-root .quiz-alternative-description {\n    color: #4b5563 !important;\n    margin-bottom: 0.75rem !important;\n}\n\nbody #camera-quiz-root .quiz-alternative-price {\n    font-size: 1.125rem !important;\n    font-weight: 600 !important;\n    color: #3b82f6 !important;\n    margin-bottom: 0.75rem !important;\n}\n\n/* List Styles */\nbody #camera-quiz-root .quiz-highlights-list {\n    list-style: none !important;\n    margin: 0 !important;\n    padding: 0 !important;\n}\n\nbody #camera-quiz-root .quiz-highlight-item {\n    display: flex !important;\n    align-items: start !important;\n    margin-bottom: 0.5rem !important;\n    color: #4b5563 !important;\n}\n\nbody #camera-quiz-root .quiz-bullet {\n    margin-right: 0.5rem !important;\n}\n\n/* Restart Button */\nbody #camera-quiz-root .quiz-restart-button {\n    width: 100% !important;\n    padding: 1rem !important;\n    background: #3b82f6 !important;\n    color: white !important;\n    border: none !important;\n    border-radius: 12px !important;\n    font-weight: 600 !important;\n    cursor: pointer !important;\n    transition: background-color 0.2s ease !important;\n    text-align: center !important;\n}\n\nbody #camera-quiz-root .quiz-restart-button:hover {\n    background: #2563eb !important;\n}\n\n/* Loading State */\nbody #camera-quiz-root .quiz-loading {\n    text-align: center !important;\n    padding: 2rem !important;\n    color: #6b7280 !important;\n}\n\n/* Mobile Styles */\n@media (max-width: 640px) {\n    /* Container Anpassungen */\n    body #camera-quiz-root .camera-quiz-container {\n        margin: 1rem auto !important;\n        padding: 0 0.5rem !important;\n    }\n\n    /* Content Padding verringern */\n    body #camera-quiz-root .quiz-content {\n        padding: 1.5rem 1rem !important;\n    }\n    \n    /* Kleinere Überschrift */\n    body #camera-quiz-root .quiz-question {\n        font-size: 1.25rem !important;\n        margin: 10px 10px 20px 10px !important;\n    }\n\n    /* Button Anpassungen */\n    body #camera-quiz-root .quiz-button {\n        padding: 0.875rem 1rem !important;\n        min-height: 60px !important;\n    }\n\n    body #camera-quiz-root .quiz-button span {\n        font-size: 0.9rem !important;\n        line-height: 1.3 !important;\n    }\n\n    body #camera-quiz-root .quiz-button svg {\n        width: 20px !important;\n        height: 20px !important;\n        margin-right: 0.75rem !important;\n    }\n\n    /* Selection Counter */\n    body #camera-quiz-root .quiz-selection-counter {\n        font-size: 0.8rem !important;\n        margin: -10px 10px 10px 10px !important;\n    }\n\n    /* Back Button */\n    body #camera-quiz-root .quiz-back-button {\n        padding: 0.875rem 1rem !important;\n    }\n}\n\n/* Noch kleinere Bildschirme */\n@media (max-width: 380px) {\n    body #camera-quiz-root .quiz-content {\n        padding: 1rem 0.5rem !important;\n    }\n\n    body #camera-quiz-root .quiz-button {\n        padding: 0.75rem 0.875rem !important;\n    }\n\n    body #camera-quiz-root .quiz-button span {\n        font-size: 0.85rem !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
